// src/components/store/sections/newsletter/NewsletterV9CathedralinviteFuchsiaGlow.tsx
"use client";

import React from "react";
import DynamicNewsletterVariant from "./DynamicNewsletterVariant";

export default function NewsletterV9CathedralinviteFuchsiaGlow(props: any) {
  return (
    <DynamicNewsletterVariant
      variantNumber={9}
      archKey="cathedral_invite"
      archLabel="Cathedral Arch Invite"
      palName="FuchsiaGlow"
      grad="from-fuchsia-500 via-pink-500 to-purple-700"
      lightBg="bg-fuchsia-50"
      textCol="text-fuchsia-700"
      borderCol="border-fuchsia-200"
      btnCls="bg-fuchsia-600 hover:bg-fuchsia-700"
      hexCol="#d946ef"
      {...props}
    />
  );
}
